import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import type { Observable, Subject } from "rxjs";
import { from } from "rxjs";
import { distinctUntilChanged, filter, switchMap } from "rxjs/operators";
import { BONUSX_ACCESS_TOKEN } from "../../constants/env";
import { authStateService } from "../../legacy/services/authentication-service/auth-state/auth-state.service.instance";
import { questionnaireService } from "../../legacy/services/questionnaire/questionnaire.service.instance";
import { handleQuestionnaire } from "../../legacy/stores/questionnaire/handleQuestionnaire";
import { trackQuestionnairePersistence } from "../../legacy/stores/questionnaire/questionnaire-persistence-tracker";
import { getCookie } from "../../legacy/utils/getCookie";
import { serializeForDiffCheck } from "../../legacy/utils/serializeForDiffCheck";

function areCitizenNameAndEmailProvided(current: RootStoreModule.State): boolean {
  const citizenName = current.formValues.Nome;
  const citizenEmail = current.formValues.email;
  return !isNil(citizenName) && !isNil(citizenEmail);
}

export function createQuestionnairePersist$(
  questionnaireSubject$: Subject<RootStoreModule.State>
): Observable<unknown> {
  return questionnaireSubject$.pipe(
    filter(function isSessionActive() {
      const hasAccessTokenCookie = Boolean(getCookie(BONUSX_ACCESS_TOKEN));
      return hasAccessTokenCookie && authStateService.isAuthenticated();
    }),
    distinctUntilChanged(function isDiffState(previous, current) {
      const currentHasCitizenNameAndEmail = areCitizenNameAndEmailProvided(current);
      if (currentHasCitizenNameAndEmail) {
        const isTheSame = isEqual(
          serializeForDiffCheck(previous.formValues),
          serializeForDiffCheck(current.formValues)
        );
        return isTheSame;
      }
      return !currentHasCitizenNameAndEmail;
    }),
    filter((data: RootStoreModule.State) => {
      const isInitialized = data.questionnaireHasBeenDownloaded;
      return isInitialized;
    }),
    switchMap((data) => {
      const handledData = handleQuestionnaire(data);
      trackQuestionnairePersistence(handledData);
      return from(handledData);
    })
  );
}

export function subscribeToQuestionnairePersist(questionnaireSubject$: Subject<RootStoreModule.State>) {
  questionnaireService.unsubscribeAndClear();

  const subscription = createQuestionnairePersist$(questionnaireSubject$).subscribe({
    next: function onResponseReceived(data) {
      console.debug("Questionnaire response:", data);
    },
    error: function onError(error) {
      console.warn("Questionnaire error:", error);
      subscribeToQuestionnairePersist(questionnaireSubject$);
    },
    complete: function onComplete() {
      console.debug("Questionnaire stop listen");
      subscribeToQuestionnairePersist(questionnaireSubject$);
    },
  });

  questionnaireService.bindSubscription(subscription);
}
